import Util from '@/mixins/util'
import log from 'loglevel'
/**
 * 分から時分に変換する
 * @param {Number} minute 分
 * @returns {Object} 時分
 */
export function getTimeFromMinute(minute) {
  let time = {
    minutes: 0,
    hours: 0,
  }
  const hour = 60
  if (minute < hour) {
    // 60分未満の場合、そのままminutesに代入
    time.minutes = minute
  } else {
    // 60分以上の場合、時間・分に切り分けて代入
    time.hours = Math.floor(minute / hour)
    time.minutes = minute % hour
  }

  return time
}

/**
 * 分から「○時間○分」の文字列に変換する
 * @param {Number} minute 分
 * @returns {String} 時分 + 単位
 */
export function transferMinuteToText(minutes) {
  const time = getTimeFromMinute(minutes)
  return time.hours === 0 // eslint-disable-line no-magic-numbers
    ? `${time.minutes}分`
    : `${time.hours}時間${time.minutes}分`
}

/**
 * オブジェクトが空オブジェクトであるか否か
 * @param {*} obj オブジェクト
 */
export function isEmpty(obj) {
  return Object.keys(obj).length === 0 // eslint-disable-line no-magic-numbers
}

/**
 * 距離表示処理(非表示含む)
 * @param {number} distance 距離(m)
 * @returns 変換後の距離情報(距離の単位とスペース表記あり)
 */
export function getDistanceText(distanceM) {
  // 1000m未満
  if (!Util.methods.isKilo(distanceM)) return `${distanceM}m・`

  // 「XXXkm」の表現判定は共通処理にて
  // 下2桁で四捨五入を行うために99950を境界値として設定
  const [dPointZero, dPointOne, hundredKilo] = [0, 1, 99950] // eslint-disable-line no-magic-numbers
  if (hundredKilo <= distanceM) {
    // XXXkmを表現
    return `${Util.methods.roundAndConvertToKilo(distanceM, dPointZero)}km・`
  } else {
    // 1.0~99.9kmを表現
    return `${Number(
      Util.methods.roundAndConvertToKilo(distanceM, dPointOne)
    ).toFixed(dPointOne)}km・`
  }
}
/**
 * 二点間の距離を算出
 * @param {Object} point1 地点1の座標
 * @param {Number} point1.lat 地点1の緯度
 * @param {Number} point1.lon 地点1の経度
 * @param {Object} point2 地点2の座標
 * @param {Number} point2.lat 地点2の緯度
 * @param {Number} point2.lon 地点2の経度
 * @return 距離(m)
 */
export function calcDistance(point1, point2) {
  // 二地点のどちらかが未設定の場合、算出を行わない
  const checkInvalidCoord = (c) => c.lat == null || c.lon == null
  if (checkInvalidCoord(point1) || checkInvalidCoord(point2)) return

  // 二点間の距離を算出する
  let distanceM
  try {
    /* eslint-disable no-undef */
    const p1LatLon = new mapscript.value.LatLng(point1.lat, point1.lon)
    const p2LatLon = new mapscript.value.LatLng(point2.lat, point2.lon)
    distanceM = mapscript.util.calcDistance(p1LatLon, p2LatLon)
    /* eslint-enable no-undef */
  } catch (e) {
    log.warn('calcDistance failed.', e)
    return
  }
  // 四捨五入して返却
  return Math.round(distanceM)
}
